import ValidForm from './validForm';
import isDevice from './utils';

let formValidation = {
    startBankIDApp: function (token) {
  
        const iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

        if (iOS) {
            let url = encodeURIComponent(window.location.href);
            if (navigator.userAgent.match('CriOS')) { url = 'googlechrome://' + url; }
            else if (navigator.userAgent.match('FxiOS')) { url = 'firefox://open-url?url=' + url; }
            else if (navigator.userAgent.match('GSA')) { url = 'googleapp://open-url?url=' + url; }

            //return this.URLS.BANK_ID_URLS.ios(this.autoStartToken, url);
            window.location.href = 'https://app.bankid.com/?autostarttoken='.concat(token).concat('&redirect=').concat(url);
        }

        window.location.href = 'bankid:///?autostarttoken='.concat(token).concat('&redirect=null');
    },
    isDevice: function () {
        //console.log('[form-validation] isDevice');

        var mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(navigator.userAgent);

        return mobile;
        //return isDevice();
    },
    initValidForm: function () {
        const formEl = document.querySelector('.dynamic-form');

        if (formEl) {
            ValidForm(formEl, {
                invalidClass: 'is-invalid',
                validationErrorClass: 'invalid-feedback',
                errorPlacement: 'after'
            });
        }



    },
    clearInput: function (inputId) {
        setTimeout(function () {
            var input = document.getElementById(inputId);
            if (input) {
                input.value = "";
            }
        }, 30);
    }
}
export { formValidation };
